import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/(platform)/_components/sidebar/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider","SidebarInset","SidebarTrigger"] */ "/vercel/path0/src/components/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformProviders"] */ "/vercel/path0/src/lib/providers/platformProviders.tsx");
